import { z } from "zod";
export var DmaFramework;
(function (DmaFramework) {
    DmaFramework["MoleFractionBased"] = "MoleFractionBased";
    DmaFramework["MolalityBasedLegacy"] = "MolalityBasedLegacy";
    DmaFramework["MolalityBased"] = "MolalityBased";
})(DmaFramework || (DmaFramework = {}));
export const dmaFrameworkDtoSchema = z.nativeEnum(DmaFramework);
